import { defineComponent as _defineComponent } from 'vue';
import ToolHelpMarkdown from "./ToolHelpMarkdown.vue";
import ToolHelpRst from "./ToolHelpRst.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolHelp',
    props: {
        format: null,
        content: null
    },
    setup(__props) {
        return { __sfc: true, ToolHelpMarkdown, ToolHelpRst };
    }
});
